import { render, staticRenderFns } from "./RekapNotaPerKapal.vue?vue&type=template&id=28c486f0&scoped=true&"
import script from "./RekapNotaPerKapal.vue?vue&type=script&lang=js&"
export * from "./RekapNotaPerKapal.vue?vue&type=script&lang=js&"
import style0 from "./RekapNotaPerKapal.vue?vue&type=style&index=0&id=28c486f0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c486f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow,VTextField})
